import { css } from "@emotion/css";
import styled from "@emotion/styled";
import classNames from "classnames";
import * as React from "react";
import ReactModal from "react-modal";

import { IconButton } from "@alchemy/ui";
import { X03 } from "@alchemy/ui/icons/24";
import theme from "../../styles/theme";

const contentClassName = css`
  position: relative;
  max-width: 588px;
  width: 100%;
  margin: auto;
  padding: 24px 32px 32px;
  border-radius: 16px;
  background: #fff;
  outline: none;
  transform: translateY(20px);
  transition: transform 150ms ease-in-out;
`;

const overlayClassName = css`
  position: fixed;
  z-index: 100;
  inset: 0;
  display: flex;
  flex-direction: column;
  padding: 20px;
  background: rgba(0, 0, 0, 0.7);
  overflow-y: auto;

  opacity: 0;
  transition: opacity 150ms ease-in-out;

  &.ReactModal__Overlay--after-open {
    opacity: 1;

    .ReactModal__Content {
      transform: none;
    }
  }

  &.ReactModal__Overlay--before-close {
    opacity: 0;

    .ReactModal__Content {
      transform: translateY(20px);
    }
  }
`;

const htmlOpenClassName = css`
  overflow: hidden;
`;

export const ModalHeader = styled.h2`
  font-size: 18px;
  font-weight: 500;
  color: ${theme.colors.black};
  margin: 0px 0px 16px 0px;
`;

export const ModalText = styled.p`
  font-size: 14px;
  font-weight: 400;
  color: ${theme.colors.gray[5]};
  margin: 0px;
`;

interface ModalProps {
  isOpen: boolean;
  onClose?: () => void;
  className?: string;
  children: React.ReactNode;
}

const Modal = ({ isOpen, onClose, className, children }: ModalProps) => {
  return (
    <ReactModal
      isOpen={isOpen}
      closeTimeoutMS={200}
      onRequestClose={onClose}
      className={classNames(contentClassName, className)}
      overlayClassName={overlayClassName}
      htmlOpenClassName={htmlOpenClassName}
    >
      {onClose && (
        <IconButton onClick={onClose} className="absolute right-4 top-3 z-10">
          <X03 />
        </IconButton>
      )}
      {children}
    </ReactModal>
  );
};

export default Modal;
